import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
// @mui
import PropTypes from 'prop-types';
import { alpha, styled } from '@mui/material/styles';
import { Card, Divider, Grid, Stack, Typography } from '@mui/material';
import Iconify from '../../../components/iconify';
// utils
// import { fShortenNumber } from '../../../utils/formatNumber';
// components

// ----------------------------------------------------------------------

const StyledIcon = styled('div')(({ theme }) => ({
  margin: 'auto',
  display: 'flex',
  borderRadius: '50%',
  alignItems: 'center',
  width: theme.spacing(8),
  height: theme.spacing(8),
  justifyContent: 'center',
  marginBottom: theme.spacing(3),
}));

// ----------------------------------------------------------------------

AppWidgetSummary.propTypes = {
  color: PropTypes.string,
  icon: PropTypes.string,
  title: PropTypes.string.isRequired,
  total: PropTypes.number.isRequired,
  sx: PropTypes.object,
  navigateUrl: PropTypes.string
};

export default function AppWidgetSummary({ title, total, icon, color = 'primary', sx, navigateUrl = '', ...other }) {
  const navigate = useNavigate()
  const [userRole, setUserRole] = useState(localStorage.getItem('role'))
  const [navigatePath, setNavigatePath] = useState(null)
  useEffect(() => {
    setNavigatePath(navigateUrl)
    console.log('navigateUrl', navigateUrl)
  }, [])
  return (
    // <Card
    //   onClick={() => {
    //     navigate(navigatePath)
    //   }}
    //   sx={{
    //     py: 5,
    //     boxShadow: 0,
    //     textAlign: 'center',
    //     color: (theme) => theme.palette[color].darker,
    //     bgcolor: (theme) => theme.palette[color].lighter,
    //     ...sx,
    //   }}
    //   {...other}
    // >
    //   <Typography variant="subtitle2" sx={{ opacity: 0.72 }}>
    //     {title}
    //   </Typography>
    //   <StyledIcon
    //     sx={{
    //       color: (theme) => theme.palette[color].dark,
    //       backgroundImage: (theme) =>
    //         `linear-gradient(135deg, ${alpha(theme.palette[color].dark, 0)} 0%, ${alpha(
    //           theme.palette[color].dark,
    //           0.24
    //         )} 100%)`,
    //     }}
    //   >
    //     <Iconify icon={icon} width={24} height={24} />
    //   </StyledIcon>

    //   <Typography variant="h3">{total}</Typography>


    // </Card>
    <Card
      onClick={() => {
        navigate(navigatePath)
      }}
      sx={{
        py: 5,
        px: 5,
        // boxShadow: (theme) => `${alpha(theme.palette[color].dark, 0.07)} 0px 7px 29px 0px`,
        backgroundColor: (theme) => `${alpha(theme.palette[color].dark, 0.07)}`,
        // boxShadow: (theme) => `${alpha(theme.palette[color].dark, 0.25)} 0px 30px 60px -12px inset,${alpha(theme.palette[color].dark, 0.3)} 0px 18px 36px -18px inset`,
        textAlign: 'center',
        border: (theme) => `1px solid ${alpha(theme.palette[color].dark, 0.24)}`
      }}
    >
      <Grid Container sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>

        <Grid item xs={3} sm={3} md={3} lg={3} xl={3}>
          <StyledIcon
            sx={{
              color: (theme) => theme.palette[color].dark,
              backgroundImage: (theme) =>
                `linear-gradient(135deg, ${alpha(theme.palette[color].dark, 0)} 0%, ${alpha(
                  theme.palette[color].dark,
                  0.24
                )} 100%)`,
            }}
          >
            <Iconify icon={icon} width={24} height={24} />
          </StyledIcon>
        </Grid>
        <Grid item xs={8} sm={8} md={8} lg={8} xl={8}>
          <Stack direction={'column'}>
            <Typography variant="subtitle2" sx={{
              color: (theme) => theme.palette[color].dark,
              opacity: 0.72
            }}>
              {title}
            </Typography>
            <Typography variant="h3">{total}</Typography>
          </Stack>
        </Grid>
      </Grid>

    </Card>
  );
}
